$(document).ready(function()
{
    
    function salesConfirmation()
    {
        currentCartItems = localStorage.removeItem('currentCartItems');
    };

    if ( $('#salesConfirmation').length )
    {
        salesConfirmation();
    }


});